import { render, staticRenderFns } from "./alert-count-badge.vue?vue&type=template&id=a7ab9fe8&scoped=true&functional=true"
import script from "./alert-count-badge.vue?vue&type=script&lang=js"
export * from "./alert-count-badge.vue?vue&type=script&lang=js"
import style0 from "./alert-count-badge.vue?vue&type=style&index=0&id=a7ab9fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a7ab9fe8",
  null
  
)

export default component.exports